import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";
import React, { useEffect, useState } from "react";
import { IDataSet } from "../charts/interfaces";

interface IColumnTabWithMapperProps {
  value: number | string;
  valueDecimalPlaces: number;
  dataset: IDataSet;
}
export default function ColumnTabWithMapper({
  value,
  valueDecimalPlaces,
  dataset,
}: IColumnTabWithMapperProps) {
  const [newValue, setNewValue] = useState(value);
  const { data, isLoading } = useGetDatasetMapperData(
    dataset?.stringValueMapper!);

  useEffect(() => {
    if(!isLoading) {
      getNewValue(value);
    }
  }, [isLoading]);

  const getNewValue = (value: number | string) => {
    if (dataset.stringValueMapper && data?.mappings) {
      for (let i = 0; i < Object.keys(data.mappings).length; i++) {
        if (Object.keys(data.mappings)[i] == value) {
          setNewValue(data.mappings[i]);
        }
      }
    } else {
      setNewValue(value);
    }
  };

  return (
    <>
      {typeof newValue === "number"
        ? newValue.toFixed(valueDecimalPlaces)
        : typeof newValue === "string"
        ? newValue
        : "-"}
    </>
  );
}
